import $http from '@/api/index'
import axios from 'axios'
//注册审批时修改用户信息
export function UpdateContactUserInfo(jobj) {
  let getUrl = {
    method: 'POST',
    url: 'user/UpdateContactUserInfo',
    requestType: 2
  }
  let params = {
    Auditcontactuserinfo: jobj
  }
  return $http(getUrl, params)
}

//获取组织机构
export function GetDeptByName(name, companyId) {
  let getUrl = {
    method: 'GET',
    url: 'user/GetDeptByName?name=' +
      name +
      '&companyId=' +
      companyId,
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

/**
 * 更加组织机构获取用户信息
 * @param {boolean} isRight
 * @param {string} input
 * @param {string} companyType
 */
export function GetAllCustomerVWInfo(isRight, input, companyType) {
  let getUrl = {
    method: 'GET',
    url: 'user/GetAllCustomerVWInfo?isRight=' +
      isRight +
      '&input=' +
      input +
      '&companyType=' +
      companyType,
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}


export function GetUserTreeByCompanyExIdNew1(companyExId, isContainDisenable, needAuth, userId = 'super') {
  let getUrl = {
    method: 'GET',
    url: 'user/GetUserTreeByCompanyExIdNew1?companyExId=' +
      companyExId +
      '&isContainDisenable=' +
      isContainDisenable +
      '&needAuth=' +
      needAuth +
      '&userId=' + userId,
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

export function GetUserTreeByDeptIdNew1(deptId, isContainDisenable, needAuth, userId = 'super') {
  let getUrl = {
    method: 'GET',
    url: 'user/GetUserTreeByDeptIdNew1?deptId=' +
      deptId +
      '&isContainDisenable=' +
      isContainDisenable +
      '&needAuth=' +
      needAuth +
      '&userId=' + userId,
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

export function GetAccessToken() {
  let getUrl = {
    method: 'GET',
    url: 'openId.ashx',
    requestType: 6
  }
  let params = {}
  return $http(getUrl, params)
}

/**
 * 获取用户所在的所有科室
 * @param {string} userId
 */
export function GetPubDeptByUserId(userId) {
  let getUrl = {
    method: 'GET',
    url: `user/GetPubDeptByUserId?userId=${userId}`,
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}

/**
 * 根据科室ID获取当前科室下的所有在用的人员
 * @param {*} deptID 科室ID
 * @param {*} userType 查询的类型 0 默认科室下所有 1 科室主负责人 2 科室副负责人
 */
export function GetDeptUser (deptID, userType = 0) {
  const getUrl = {
    method: 'GET',
    url: 'User/GetDeptUser',
    requestType: 2
  }
  const para = {
    deptID,
    userType
  }
  return $http(getUrl, para)
}